import React, { useState } from 'react';

// ── Config types ──────────────────────────────────────────────────────────────
const TYPE_CFG = {
  codir:     { label: 'CODIR',     color: '#C9A84C', icon: '👑' },
  equipe:    { label: 'Équipe',    color: '#42a5f5', icon: '👥' },
  client:    { label: 'Client',    color: '#66bb6a', icon: '🤝' },
  formation: { label: 'Formation', color: '#ab47bc', icon: '📚' },
  projet:    { label: 'Projet',    color: '#26c6da', icon: '📋' },
  urgente:   { label: 'Urgente',   color: '#ef5350', icon: '🔴' },
  autre:     { label: 'Autre',     color: '#888',    icon: '📋' },
  commercial:    { label: 'Commercial',    color: '#C9A84C', icon: '💼' },
  partenariat:   { label: 'Partenariat',   color: '#66bb6a', icon: '🤝' },
  institutionnel:{ label: 'Institutionnel',color: '#42a5f5', icon: '🏛️' },
  suivi:         { label: 'Suivi',         color: '#26c6da', icon: '🔄' },
  fiscal:        { label: 'Fiscal',        color: '#ff9800', icon: '📊' },
  banque:        { label: 'Banque',        color: '#64b5f6', icon: '🏦' },
};

const MOIS = ['Janvier','Février','Mars','Avril','Mai','Juin','Juillet','Août','Septembre','Octobre','Novembre','Décembre'];
const TODAY = new Date().toISOString().slice(0, 10);
const fmtDate = d => d ? d.split('-').reverse().join('/') : '';

// ── Données initiales (communes) ─────────────────────────────────────────────
const REUNIONS_BASE = [
  { id: 1, titre: 'CODIR Juin 2026 — Bilan mensuel', type: 'codir', date: '2026-06-10', hstart: '09:00', hend: '11:00', duree: '2 heures', lieu: 'FHC Siège — Salle principale', format: 'Présentiel', org: 'Direction Générale', participants: ['Karmelle H.', 'Jean-Paul A.', 'Marie B.', 'Ola K.', 'Serge D.'], odj: '1. Bilan mai 2026\n2. Projets EMPLOI+ et AfricaLocation\n3. Finance et trésorerie\n4. RH et alertes\n5. Décisions', statut: 'a_venir' },
  { id: 2, titre: 'Réunion tech — Sprint S23 EMPLOI+', type: 'equipe', date: '2026-06-05', hstart: '10:00', hend: '11:00', duree: '1 heure', lieu: 'FHC Siège — Salle 2', format: 'Présentiel', org: 'Jean-Paul A.', participants: ['Jean-Paul A.', 'Karmelle H.'], odj: '1. Avancement sprint S22\n2. Blocages\n3. Sprint S23', statut: 'tenue' },
  { id: 3, titre: 'Signature convention MICPME', type: 'client', date: '2026-06-07', hstart: '14:00', hend: '15:00', duree: '1 heure', lieu: 'Ministère MICPME — Cotonou', format: 'Présentiel', org: 'Direction Générale', participants: ['Karmelle H.', 'Direction'], odj: 'Signature convention formation Q3 2026', statut: 'a_venir' },
  { id: 4, titre: 'Partenariat ANPE x EMPLOI+', type: 'client', date: '2026-06-15', hstart: '10:00', hend: '11:00', duree: '1 heure', lieu: 'ANPE — Cotonou', format: 'Présentiel', org: 'Serge D.', participants: ['Serge D.', 'Karmelle H.'], odj: 'Finalisation convention API', statut: 'a_venir' },
  { id: 5, titre: 'Clôture comptable mensuelle', type: 'fiscal', date: '2026-06-30', hstart: '09:00', hend: '11:00', duree: '2 heures', lieu: 'FHC Siège — Bureau compta', format: 'Présentiel', org: 'Marie B.', participants: ['Marie B.', 'Direction Générale'], odj: '1. Rapprochement bancaire final\n2. TVA à déclarer\n3. Préparation états financiers', statut: 'a_venir' },
  { id: 6, titre: 'Réunion banque SGBBE — financement', type: 'banque', date: '2026-06-12', hstart: '11:00', hend: '12:00', duree: '1 heure', lieu: 'SGBBE — Cotonou', format: 'Présentiel', org: 'Marie B.', participants: ['Marie B.', 'Direction Générale'], odj: 'Négociation ligne de crédit', statut: 'a_venir' },
];

const RDV_BASE = [
  { id: 1, objet: 'Présentation offre accompagnement BOA', contact: 'BOA Bénin — DAF', type: 'commercial', date: '2026-06-05', heure: '14:00', duree: '1h30', lieu: 'Siège BOA, Cotonou', resp: 'Karmelle H.', statut: 'confirme', notes: 'Préparer proposition détaillée', priorite: 'haute' },
  { id: 2, objet: 'Convention formation Q3 MICPME', contact: 'MICPME — Dir. Cabinet', type: 'institutionnel', date: '2026-06-07', heure: '14:00', duree: '1 heure', lieu: 'Ministère MICPME', resp: 'Karmelle H.', statut: 'confirme', notes: 'Apporter convention signée', priorite: 'haute' },
  { id: 3, objet: 'Entretien recrutement Dev Mobile', contact: 'Candidat RAKOTO', type: 'suivi', date: '2026-06-09', heure: '10:00', duree: '1 heure', lieu: 'FHC Siège — Salle 2', resp: 'Jean-Paul A.', statut: 'confirme', notes: 'CV Flutter 3 ans', priorite: 'haute' },
  { id: 4, objet: 'RDV DGI — régularisation TVA', contact: 'DGI Bénin — CIPE 1', type: 'fiscal', date: '2026-06-14', heure: '09:00', duree: '1 heure', lieu: 'DGI — Abomey-Calavi', resp: 'Marie B.', statut: 'confirme', notes: 'Apporter déclarations mai', priorite: 'haute' },
  { id: 5, objet: 'Audit annuel CNSS', contact: 'CNSS — Inspecteur', type: 'fiscal', date: '2026-06-18', heure: '10:00', duree: '2 heures', lieu: 'FHC Siège', resp: 'Marie B.', statut: 'a_confirmer', notes: 'Préparer registres paie', priorite: 'normale' },
];

const DECISIONS_BASE = [
  { id: 1, texte: 'Recruter un développeur mobile junior avant le 15 juin', resp: 'Direction Générale', echeance: '2026-06-15', prio: 'haute', source: 'CODIR Mai 2026', statut: 'en_cours', done: false },
  { id: 2, texte: 'Envoyer mise en demeure Mairie Cotonou — facture 708 000 FCFA', resp: 'Marie B.', echeance: '2026-06-10', prio: 'haute', source: 'CODIR Mai 2026', statut: 'retard', done: false },
  { id: 3, texte: 'Planifier formation ADPME — semaine du 8 juillet', resp: 'Ola K.', echeance: '2026-06-20', prio: 'normale', source: 'CODIR Mai 2026', statut: 'fait', done: true },
  { id: 4, texte: 'Renouveler domaine fhcgroupebenin.com', resp: 'Jean-Paul A.', echeance: '2026-06-03', prio: 'haute', source: 'CODIR Mai 2026', statut: 'retard', done: false },
  { id: 5, texte: 'Déclarer TVA Mai avant le 15 juin', resp: 'Marie B.', echeance: '2026-06-15', prio: 'haute', source: 'Clôture compta', statut: 'en_cours', done: false },
];

const PVS_BASE = [
  {
    id: 1, reunion: 'CODIR Mai 2026', dateReunion: '10/05/2026', dateRed: '11/05/2026',
    redacteur: 'Karmelle H.',
    presents: ['Karmelle H.', 'Jean-Paul A.', 'Marie B.', 'Ola K.', 'Serge D.'],
    excuses: ['Ayodele F.', 'Patrick L.'],
    odj: '1. Bilan avril\n2. Projets\n3. Finance\n4. RH',
    points: '1. Bilan avril : CA 1,4M FCFA, objectif 1,2M dépassé.\n2. Projets : EMPLOI+ v2 en retard de 2 semaines.\n3. Finance : Facture Mairie 708 000 FCFA impayée depuis 46 jours.\n4. RH : Absences répétées à régulariser.',
    decisions: ['Recruter développeur mobile avant le 15 juin — Resp. : Direction', 'Envoyer mise en demeure Mairie Cotonou — Resp. : Marie B.', 'Planifier formation ADPME juillet — Resp. : Ola K.'],
    nextDate: '10/06/2026', nextHeure: '09:00',
  },
];

// ── Helpers internes ──────────────────────────────────────────────────────────
function inp(style = {}) {
  return {
    background: 'rgba(255,255,255,.05)', border: '1px solid rgba(255,255,255,.1)',
    borderRadius: 7, padding: '8px 11px', color: '#fff', fontFamily: 'inherit',
    fontSize: 12, outline: 'none', width: '100%', ...style,
  };
}

function StatBadge({ s }) {
  const map = {
    a_venir: ['#ce93d8', 'Planifiée'], tenue: ['#66bb6a', '✅ Tenue'],
    confirme: ['#66bb6a', '✅ Confirmé'], a_confirmer: ['#ffb74d', '⏳ À confirmer'],
    en_cours: ['#C9A84C', 'En cours'], retard: ['#ef8080', '🚨 Retard'],
    fait: ['#66bb6a', '✅ Fait'],
  };
  const [c, l] = map[s] || ['#aaa', s];
  return <span style={{ fontSize: 9, fontWeight: 700, padding: '2px 8px', borderRadius: 99, background: c + '22', color: c }}>{l}</span>;
}

// ── Composant principal ───────────────────────────────────────────────────────
export default function AgendaSection({ filterTypes }) {
  const [tab, setTab] = useState('agenda');
  const [reunions, setReunions] = useState(
    filterTypes ? REUNIONS_BASE.filter(r => filterTypes.includes(r.type)) : REUNIONS_BASE
  );
  const [rdvList, setRdvList] = useState(
    filterTypes ? RDV_BASE.filter(r => filterTypes.includes(r.type)) : RDV_BASE
  );
  const [decisions, setDecisions] = useState(DECISIONS_BASE);
  const [pvs, setPvs] = useState(PVS_BASE);

  // calendrier
  const [calNav, setCalNav] = useState(() => { const d = new Date(); return { y: d.getFullYear(), m: d.getMonth() }; });
  const [selDay, setSelDay] = useState(TODAY);

  // modals
  const [modal, setModal] = useState(null);
  const [form, setForm] = useState({});
  const [detailReunion, setDetailReunion] = useState(null);
  const [detailRdv, setDetailRdv] = useState(null);
  const [pvPreview, setPvPreview] = useState(pvs[0] || null);

  const closeModal = () => { setModal(null); setForm({}); };

  // ── Calendrier ──
  const { y, m } = calNav;
  const firstDay = new Date(y, m, 1).getDay();
  const daysInMonth = new Date(y, m + 1, 0).getDate();
  const off = firstDay === 0 ? 6 : firstDay - 1;
  const allEvts = [...reunions.map(r => ({ ...r, heure: r.hstart })), ...rdvList];
  const evtsByDate = {};
  allEvts.forEach(e => { if (!evtsByDate[e.date]) evtsByDate[e.date] = []; evtsByDate[e.date].push(e); });

  // ── Sauvegarde réunion ──
  const saveReunion = () => {
    if (!form.titre) return;
    const parts = form.participants ? form.participants.split(',').map(p => p.trim()) : [];
    const r = { id: form._id || Date.now(), titre: form.titre, type: form.type || 'equipe', date: form.date || TODAY, hstart: form.hstart || '09:00', hend: form.hend || '10:00', duree: form.duree || '1 heure', lieu: form.lieu || 'FHC Siège', format: form.format || 'Présentiel', org: form.org || '—', participants: parts, odj: form.odj || '—', statut: 'a_venir' };
    if (form._isEdit) setReunions(prev => prev.map(x => x.id === r.id ? r : x));
    else setReunions(prev => [...prev, r]);
    closeModal();
  };

  // ── Sauvegarde RDV ──
  const saveRdv = () => {
    if (!form.objet) return;
    const r = { id: form._id || Date.now(), objet: form.objet, contact: form.contact || '—', type: form.type || 'commercial', date: form.date || TODAY, heure: form.heure || '09:00', duree: form.duree || '1 heure', lieu: form.lieu || '—', resp: form.resp || '—', statut: form.statut || 'a_confirmer', notes: form.notes || '', priorite: form.priorite || 'normale' };
    if (form._isEdit) setRdvList(prev => prev.map(x => x.id === r.id ? r : x));
    else setRdvList(prev => [...prev, r]);
    closeModal();
  };

  // ── Sauvegarde PV ──
  const savePV = () => {
    if (!form.points) return;
    const decs = form.decisions ? form.decisions.split('\n').map(d => d.replace(/^[-•]\s*/, '').trim()).filter(Boolean) : [];
    const pv = {
      id: Date.now(), reunion: form.reunion || 'Réunion diverse',
      dateReunion: form.dateReunion || fmtDate(TODAY), dateRed: fmtDate(TODAY),
      redacteur: form.redacteur || '—',
      presents: form.presents ? form.presents.split(',').map(p => p.trim()) : [],
      excuses: form.excuses ? form.excuses.split(',').map(p => p.trim()) : [],
      odj: form.odj || '—', points: form.points,
      decisions: decs,
      nextDate: form.nextDate ? fmtDate(form.nextDate) : '—', nextHeure: form.nextHeure || '09:00',
    };
    // Ajouter les décisions au registre
    decs.forEach((d, i) => {
      if (d.length > 5) setDecisions(prev => [...prev, { id: Date.now() + i, texte: d.replace(/\s*—\s*Resp\..*$/, '').trim(), resp: '—', echeance: new Date(Date.now() + 14 * 86400000).toISOString().slice(0, 10), prio: 'normale', source: pv.reunion, statut: 'en_cours', done: false }]);
    });
    setPvs(prev => [pv, ...prev]);
    setPvPreview(pv);
    closeModal();
    setTab('pv');
  };

  // ── Sauvegarde décision ──
  const saveDecision = () => {
    if (!form.texte) return;
    const d = { id: Date.now(), texte: form.texte, resp: form.resp || '—', echeance: form.echeance || TODAY, prio: form.prio || 'normale', source: form.source || '—', statut: 'en_cours', done: false };
    setDecisions(prev => [...prev, d]);
    closeModal();
  };

  const Field = ({ label, name, type = 'text', opts, rows }) => (
    <div style={{ marginBottom: 10 }}>
      <label style={{ fontSize: 9, color: '#667', textTransform: 'uppercase', letterSpacing: '.8px', display: 'block', marginBottom: 4 }}>{label}</label>
      {opts ? (
        <select style={inp()} value={form[name] || ''} onChange={e => setForm(f => ({ ...f, [name]: e.target.value }))}>
          <option value="">— choisir —</option>
          {opts.map(o => <option key={o.v || o} value={o.v || o}>{o.l || o}</option>)}
        </select>
      ) : rows ? (
        <textarea style={{ ...inp(), resize: 'vertical' }} rows={rows} value={form[name] || ''} onChange={e => setForm(f => ({ ...f, [name]: e.target.value })) } />
      ) : (
        <input style={inp()} type={type} value={form[name] || ''} onChange={e => setForm(f => ({ ...f, [name]: e.target.value }))} />
      )}
    </div>
  );

  // ── Tabs ──
  const TABS = [
    { id: 'agenda', label: '📅 Agenda', badge: reunions.filter(r => r.date >= TODAY).length + rdvList.filter(r => r.date >= TODAY).length },
    { id: 'reunions', label: '🤝 Réunions', badge: reunions.filter(r => r.statut === 'a_venir').length },
    { id: 'pv', label: '📄 PV', badge: pvs.length },
    { id: 'rdv', label: '🎯 RDV', badge: rdvList.filter(r => r.statut === 'confirme').length },
    { id: 'decisions', label: '✅ Décisions', badge: decisions.filter(d => !d.done).length },
  ];

  const accentColor = '#ab47bc';

  return (
    <div>
      {/* Tabs */}
      <div style={{ display: 'flex', gap: 2, borderBottom: '1px solid rgba(255,255,255,.07)', marginBottom: 20, overflowX: 'auto' }}>
        {TABS.map(t => (
          <button key={t.id} onClick={() => setTab(t.id)} style={{ padding: '10px 16px', fontSize: 12, color: tab === t.id ? accentColor : '#667', background: 'none', border: 'none', borderBottom: `2px solid ${tab === t.id ? accentColor : 'transparent'}`, cursor: 'pointer', whiteSpace: 'nowrap', display: 'flex', alignItems: 'center', gap: 5 }}>
            {t.label}
            {t.badge > 0 && <span style={{ fontSize: 9, fontWeight: 700, padding: '1px 5px', borderRadius: 99, background: tab === t.id ? accentColor + '22' : 'rgba(255,255,255,.06)', color: tab === t.id ? accentColor : '#556' }}>{t.badge}</span>}
          </button>
        ))}
      </div>

      {/* ═══ AGENDA (Calendrier) ═══ */}
      {tab === 'agenda' && (
        <div>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 16, flexWrap: 'wrap', gap: 10 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <button onClick={() => setCalNav(p => p.m === 0 ? { y: p.y - 1, m: 11 } : { ...p, m: p.m - 1 })} style={{ background: 'none', border: '1px solid rgba(255,255,255,.1)', borderRadius: 6, padding: '4px 10px', color: '#889', cursor: 'pointer' }}>‹</button>
              <span style={{ fontFamily: 'Cormorant Garamond, serif', fontSize: 18, fontWeight: 600 }}>{MOIS[m]} {y}</span>
              <button onClick={() => setCalNav(p => p.m === 11 ? { y: p.y + 1, m: 0 } : { ...p, m: p.m + 1 })} style={{ background: 'none', border: '1px solid rgba(255,255,255,.1)', borderRadius: 6, padding: '4px 10px', color: '#889', cursor: 'pointer' }}>›</button>
              <button onClick={() => { const d = new Date(); setCalNav({ y: d.getFullYear(), m: d.getMonth() }); }} style={{ fontSize: 10, padding: '5px 12px', border: '1px solid rgba(255,255,255,.1)', borderRadius: 6, background: 'transparent', color: '#889', cursor: 'pointer' }}>Aujourd'hui</button>
            </div>
            <div style={{ display: 'flex', gap: 8 }}>
              <button className="btn-gold" style={{ fontSize: 11, padding: '6px 14px' }} onClick={() => { setForm({ type: 'equipe', format: 'Présentiel' }); setModal('reunion'); }}>+ Réunion</button>
              <button className="btn-outline" style={{ fontSize: 11, padding: '6px 14px' }} onClick={() => { setForm({ type: 'commercial', statut: 'a_confirmer' }); setModal('rdv'); }}>+ RDV</button>
            </div>
          </div>

          {/* Grille calendrier */}
          <div style={{ background: '#162535', border: '1px solid rgba(255,255,255,.07)', borderRadius: 12, overflow: 'hidden' }}>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(7,1fr)', borderBottom: '1px solid rgba(255,255,255,.07)' }}>
              {['LUN','MAR','MER','JEU','VEN','SAM','DIM'].map(j => (
                <div key={j} style={{ padding: '8px 0', textAlign: 'center', fontSize: 9, color: '#445', fontWeight: 700, letterSpacing: .5, background: 'rgba(255,255,255,.02)' }}>{j}</div>
              ))}
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(7,1fr)' }}>
              {Array.from({ length: off }, (_, i) => {
                const d = new Date(y, m, 1 - off + i);
                return <div key={`p${i}`} style={{ minHeight: 80, padding: 6, borderRight: '1px solid rgba(255,255,255,.04)', borderBottom: '1px solid rgba(255,255,255,.04)', opacity: .3 }}><div style={{ fontSize: 11, color: '#556' }}>{d.getDate()}</div></div>;
              })}
              {Array.from({ length: daysInMonth }, (_, i) => {
                const d = i + 1;
                const ds = `${y}-${String(m + 1).padStart(2, '0')}-${String(d).padStart(2, '0')}`;
                const isToday = ds === TODAY;
                const isSel = ds === selDay;
                const evts = evtsByDate[ds] || [];
                return (
                  <div key={d} onClick={() => setSelDay(ds)} style={{ minHeight: 80, padding: 6, borderRight: '1px solid rgba(255,255,255,.04)', borderBottom: '1px solid rgba(255,255,255,.04)', cursor: 'pointer', background: isSel ? 'rgba(171,71,188,.08)' : 'transparent', transition: 'background .15s' }}>
                    <div style={{ fontSize: 11, fontWeight: isToday ? 700 : 400, color: isToday ? '#C9A84C' : isSel ? accentColor : '#778', background: isToday ? 'rgba(201,168,76,.15)' : 'transparent', borderRadius: '50%', width: 22, height: 22, display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 3 }}>{d}</div>
                    {evts.slice(0, 2).map((e, ei) => {
                      const tc = TYPE_CFG[e.type] || TYPE_CFG.autre;
                      return <div key={ei} onClick={ev => { ev.stopPropagation(); e.hstart ? setDetailReunion(e) : setDetailRdv(e); }} style={{ fontSize: 9, fontWeight: 600, padding: '1px 5px', borderRadius: 3, marginBottom: 2, background: tc.color + '22', color: tc.color, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{(e.hstart || e.heure)} {(e.titre || e.objet || '').slice(0, 14)}</div>;
                    })}
                    {evts.length > 2 && <div style={{ fontSize: 9, color: '#556' }}>+{evts.length - 2} autre{evts.length - 2 > 1 ? 's' : ''}</div>}
                  </div>
                );
              })}
            </div>
          </div>

          {/* Événements du jour sélectionné */}
          {selDay && (evtsByDate[selDay] || []).length > 0 && (
            <div style={{ marginTop: 16 }}>
              <div style={{ fontSize: 11, color: '#667', textTransform: 'uppercase', letterSpacing: 1, marginBottom: 10 }}>Événements du {fmtDate(selDay)}</div>
              {(evtsByDate[selDay] || []).map((e, i) => {
                const tc = TYPE_CFG[e.type] || TYPE_CFG.autre;
                return (
                  <div key={i} onClick={() => e.hstart ? setDetailReunion(e) : setDetailRdv(e)} style={{ display: 'flex', gap: 12, padding: '10px 14px', background: '#162535', border: '1px solid rgba(255,255,255,.07)', borderLeft: `3px solid ${tc.color}`, borderRadius: 8, marginBottom: 8, cursor: 'pointer' }}>
                    <div style={{ textAlign: 'center', minWidth: 44 }}><div style={{ fontFamily: 'Cormorant Garamond, serif', fontSize: 18, fontWeight: 600, color: tc.color }}>{e.hstart || e.heure}</div><div style={{ fontSize: 8, color: '#556' }}>{e.duree}</div></div>
                    <div style={{ flex: 1 }}><div style={{ fontSize: 12, fontWeight: 600, color: '#fff', marginBottom: 3 }}>{e.titre || e.objet}</div><div style={{ fontSize: 10, color: '#667' }}>📍 {e.lieu || '—'} · {tc.icon} {tc.label}</div></div>
                    <StatBadge s={e.statut} />
                  </div>
                );
              })}
            </div>
          )}
        </div>
      )}

      {/* ═══ RÉUNIONS ═══ */}
      {tab === 'reunions' && (
        <div>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
            <div style={{ display: 'flex', gap: 10, fontSize: 11 }}>
              <span style={{ color: '#ce93d8' }}>📅 {reunions.filter(r => r.statut === 'a_venir').length} à venir</span>
              <span style={{ color: '#66bb6a' }}>✅ {reunions.filter(r => r.statut === 'tenue').length} tenues</span>
            </div>
            <button className="btn-gold" style={{ fontSize: 11, padding: '6px 14px' }} onClick={() => { setForm({ type: 'equipe', format: 'Présentiel' }); setModal('reunion'); }}>+ Planifier</button>
          </div>
          {[...reunions].sort((a, b) => b.date > a.date ? 1 : -1).map(r => {
            const tc = TYPE_CFG[r.type] || TYPE_CFG.autre;
            return (
              <div key={r.id} onClick={() => setDetailReunion(r)} style={{ display: 'flex', gap: 14, padding: '14px 16px', background: '#162535', border: '1px solid rgba(255,255,255,.07)', borderRadius: 10, marginBottom: 10, cursor: 'pointer', transition: 'border-color .15s' }}
                onMouseEnter={e => e.currentTarget.style.borderColor = tc.color + '44'} onMouseLeave={e => e.currentTarget.style.borderColor = 'rgba(255,255,255,.07)'}>
                <div style={{ textAlign: 'center', minWidth: 52, flexShrink: 0 }}>
                  <div style={{ fontFamily: 'Cormorant Garamond, serif', fontSize: 18, fontWeight: 600, color: tc.color }}>{r.hstart}</div>
                  <div style={{ fontSize: 9, color: '#556', marginTop: 2 }}>{fmtDate(r.date)}</div>
                </div>
                <div style={{ width: 3, borderRadius: 99, background: tc.color, alignSelf: 'stretch', flexShrink: 0 }} />
                <div style={{ flex: 1 }}>
                  <div style={{ fontSize: 13, fontWeight: 600, color: '#fff', marginBottom: 4 }}>{r.titre}</div>
                  <div style={{ display: 'flex', gap: 12, fontSize: 10, color: '#667', flexWrap: 'wrap', marginBottom: 6 }}>
                    <span>{tc.icon} {tc.label}</span><span>📍 {r.lieu}</span><span>⏱️ {r.hstart}–{r.hend}</span><span>🖥️ {r.format}</span>
                  </div>
                  <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
                    {r.participants.slice(0, 4).map((p, i) => <span key={i} style={{ fontSize: 9, padding: '2px 7px', background: 'rgba(255,255,255,.06)', borderRadius: 99, color: '#aaa' }}>{p.split(' ')[0]}</span>)}
                    {r.participants.length > 4 && <span style={{ fontSize: 9, padding: '2px 7px', background: 'rgba(255,255,255,.06)', borderRadius: 99, color: '#556' }}>+{r.participants.length - 4}</span>}
                  </div>
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: 8 }}>
                  <StatBadge s={r.statut} />
                  <div style={{ display: 'flex', gap: 4 }} onClick={e => e.stopPropagation()}>
                    <button className="btn-outline" style={{ fontSize: 10, padding: '3px 8px' }} onClick={() => { setForm({ ...r, _isEdit: true, _id: r.id }); setModal('reunion'); }}>✏️</button>
                    <button className="btn-outline" style={{ fontSize: 10, padding: '3px 8px', color: '#ef5350' }} onClick={() => setReunions(prev => prev.filter(x => x.id !== r.id))}>🗑️</button>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}

      {/* ═══ PV ═══ */}
      {tab === 'pv' && (
        <div>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
            <span style={{ fontSize: 12, color: '#aaa' }}>{pvs.length} PV rédigé{pvs.length > 1 ? 's' : ''}</span>
            <button className="btn-gold" style={{ fontSize: 11, padding: '6px 14px' }} onClick={() => { setForm({ redacteur: 'Direction Générale' }); setModal('pv'); }}>+ Rédiger un PV</button>
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1.5fr', gap: 16 }}>
            <div>
              {pvs.map(pv => (
                <div key={pv.id} onClick={() => setPvPreview(pv)} style={{ padding: '12px 14px', background: pvPreview?.id === pv.id ? 'rgba(171,71,188,.08)' : '#162535', border: `1px solid ${pvPreview?.id === pv.id ? accentColor + '44' : 'rgba(255,255,255,.07)'}`, borderRadius: 9, marginBottom: 8, cursor: 'pointer' }}>
                  <div style={{ fontSize: 12, fontWeight: 500, color: '#fff', marginBottom: 3 }}>{pv.reunion}</div>
                  <div style={{ fontSize: 10, color: '#667' }}>Réunion du {pv.dateReunion} · PV du {pv.dateRed}</div>
                  <div style={{ fontSize: 10, color: '#778', marginTop: 3 }}>✍️ {pv.redacteur} · {pv.decisions.length} décision(s)</div>
                </div>
              ))}
              {pvs.length === 0 && <div style={{ fontSize: 12, color: '#445', padding: 16, textAlign: 'center' }}>Aucun PV rédigé.</div>}
            </div>
            <div>
              {pvPreview ? <PVDoc pv={pvPreview} /> : <div style={{ fontSize: 12, color: '#445', padding: 30, textAlign: 'center' }}>Sélectionnez un PV</div>}
            </div>
          </div>
        </div>
      )}

      {/* ═══ RDV ═══ */}
      {tab === 'rdv' && (
        <div>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
            <div style={{ display: 'flex', gap: 10, fontSize: 11 }}>
              <span style={{ color: '#66bb6a' }}>✅ {rdvList.filter(r => r.statut === 'confirme').length} confirmés</span>
              <span style={{ color: '#ffb74d' }}>⏳ {rdvList.filter(r => r.statut === 'a_confirmer').length} à confirmer</span>
            </div>
            <button className="btn-gold" style={{ fontSize: 11, padding: '6px 14px' }} onClick={() => { setForm({ type: 'commercial', statut: 'a_confirmer' }); setModal('rdv'); }}>+ Nouveau RDV</button>
          </div>
          {[...rdvList].sort((a, b) => a.date > b.date ? 1 : -1).map(r => {
            const tc = TYPE_CFG[r.type] || TYPE_CFG.commercial;
            return (
              <div key={r.id} onClick={() => setDetailRdv(r)} style={{ display: 'flex', gap: 14, padding: '12px 16px', background: '#162535', border: '1px solid rgba(255,255,255,.07)', borderRadius: 10, marginBottom: 8, cursor: 'pointer' }}
                onMouseEnter={e => e.currentTarget.style.borderColor = tc.color + '44'} onMouseLeave={e => e.currentTarget.style.borderColor = 'rgba(255,255,255,.07)'}>
                <div style={{ textAlign: 'center', minWidth: 46, flexShrink: 0 }}>
                  <div style={{ fontFamily: 'Cormorant Garamond, serif', fontSize: 18, fontWeight: 600, color: tc.color }}>{r.heure}</div>
                  <div style={{ fontSize: 9, color: '#556' }}>{fmtDate(r.date)}</div>
                  {r.priorite === 'haute' && <div style={{ fontSize: 8, color: '#ef8080', fontWeight: 700, marginTop: 2 }}>🔴 PRIO</div>}
                </div>
                <div style={{ width: 3, borderRadius: 99, background: tc.color, alignSelf: 'stretch', flexShrink: 0 }} />
                <div style={{ flex: 1 }}>
                  <div style={{ fontSize: 12, fontWeight: 600, color: '#fff', marginBottom: 3 }}>{r.objet}</div>
                  <div style={{ fontSize: 10, color: '#667' }}>🏢 {r.contact} · 📍 {r.lieu} · ⏱️ {r.duree}</div>
                  {r.notes && <div style={{ fontSize: 10, color: '#778', marginTop: 4, fontStyle: 'italic' }}>📎 {r.notes.slice(0, 60)}</div>}
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: 6 }}>
                  <StatBadge s={r.statut} />
                  {r.statut === 'a_confirmer' && (
                    <button className="btn-gold" style={{ fontSize: 9, padding: '2px 8px' }} onClick={e => { e.stopPropagation(); setRdvList(prev => prev.map(x => x.id === r.id ? { ...x, statut: 'confirme' } : x)); }}>✅ Confirmer</button>
                  )}
                  <div style={{ display: 'flex', gap: 4 }} onClick={e => e.stopPropagation()}>
                    <button className="btn-outline" style={{ fontSize: 9, padding: '2px 6px' }} onClick={() => { setForm({ ...r, _isEdit: true, _id: r.id }); setModal('rdv'); }}>✏️</button>
                    <button className="btn-outline" style={{ fontSize: 9, padding: '2px 6px', color: '#ef5350' }} onClick={() => setRdvList(prev => prev.filter(x => x.id !== r.id))}>🗑️</button>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}

      {/* ═══ DÉCISIONS ═══ */}
      {tab === 'decisions' && (
        <div>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
            <div style={{ display: 'flex', gap: 10, fontSize: 11 }}>
              <span style={{ color: '#66bb6a' }}>✅ {decisions.filter(d => d.done).length} exécutées</span>
              <span style={{ color: '#ef8080' }}>🚨 {decisions.filter(d => !d.done && d.statut === 'retard').length} en retard</span>
            </div>
            <button className="btn-gold" style={{ fontSize: 11, padding: '6px 14px' }} onClick={() => { setForm({ prio: 'normale' }); setModal('decision'); }}>+ Nouvelle décision</button>
          </div>
          <div className="card" style={{ padding: 0, overflow: 'hidden' }}>
            {decisions.map((d, i) => (
              <div key={d.id} style={{ display: 'flex', alignItems: 'flex-start', gap: 12, padding: '12px 16px', borderBottom: '1px solid rgba(255,255,255,.04)' }}>
                <div onClick={() => setDecisions(prev => prev.map(x => x.id === d.id ? { ...x, done: !x.done, statut: !x.done ? 'fait' : 'en_cours' } : x))}
                  style={{ width: 18, height: 18, borderRadius: 4, border: `1.5px solid ${d.done ? '#4caf50' : '#445'}`, background: d.done ? '#4caf50' : 'transparent', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 9, color: 'white', cursor: 'pointer', flexShrink: 0, marginTop: 2 }}>
                  {d.done ? '✓' : ''}
                </div>
                <div style={{ flex: 1 }}>
                  <div style={{ fontSize: 12, fontWeight: 500, color: d.done ? '#445' : '#fff', textDecoration: d.done ? 'line-through' : 'none', lineHeight: 1.4 }}>{d.texte}</div>
                  <div style={{ display: 'flex', gap: 10, fontSize: 10, color: '#667', marginTop: 4, flexWrap: 'wrap' }}>
                    <span>👤 {d.resp}</span>
                    <span style={{ color: d.statut === 'retard' && !d.done ? '#ef8080' : '#667' }}>📅 {fmtDate(d.echeance)}</span>
                    <span>📋 {d.source}</span>
                    <StatBadge s={d.done ? 'fait' : d.statut} />
                  </div>
                </div>
                <span style={{ fontSize: 9, fontWeight: 700, padding: '2px 7px', borderRadius: 99, background: d.prio === 'haute' ? 'rgba(239,83,80,.15)' : 'rgba(255,152,0,.15)', color: d.prio === 'haute' ? '#ef8080' : '#ffb74d', flexShrink: 0 }}>{d.prio}</span>
                <button className="btn-outline" style={{ fontSize: 9, padding: '2px 6px', color: '#ef5350', flexShrink: 0 }} onClick={() => setDecisions(prev => prev.filter(x => x.id !== d.id))}>🗑️</button>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* ═══ MODALS ═══ */}
      {modal === 'reunion' && (
        <ModalAgenda title={form._isEdit ? 'Modifier la réunion' : '📅 Planifier une réunion'} onSave={saveReunion} onClose={closeModal}>
          <Field label="Intitulé *" name="titre" />
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
            <Field label="Type" name="type" opts={['codir','equipe','client','formation','projet','urgente','fiscal','banque'].map(v => ({ v, l: TYPE_CFG[v]?.icon + ' ' + (TYPE_CFG[v]?.label || v) }))} />
            <Field label="Date *" name="date" type="date" />
            <Field label="Heure début" name="hstart" type="time" />
            <Field label="Heure fin" name="hend" type="time" />
            <Field label="Lieu" name="lieu" />
            <Field label="Format" name="format" opts={[{ v: 'Présentiel', l: 'Présentiel' }, { v: 'Visioconférence', l: 'Visioconférence' }, { v: 'Hybride', l: 'Hybride' }]} />
          </div>
          <Field label="Organisateur" name="org" />
          <Field label="Participants (séparés par virgule)" name="participants" />
          <Field label="Ordre du jour" name="odj" rows={3} />
        </ModalAgenda>
      )}

      {modal === 'rdv' && (
        <ModalAgenda title={form._isEdit ? 'Modifier le RDV' : '🎯 Nouveau rendez-vous'} onSave={saveRdv} onClose={closeModal}>
          <Field label="Objet *" name="objet" />
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
            <Field label="Contact / Entreprise" name="contact" />
            <Field label="Type" name="type" opts={['commercial','partenariat','institutionnel','suivi','fiscal','banque'].map(v => ({ v, l: TYPE_CFG[v]?.icon + ' ' + (TYPE_CFG[v]?.label || v) }))} />
            <Field label="Date *" name="date" type="date" />
            <Field label="Heure" name="heure" type="time" />
            <Field label="Lieu" name="lieu" />
            <Field label="Statut" name="statut" opts={[{ v: 'confirme', l: '✅ Confirmé' }, { v: 'a_confirmer', l: '⏳ À confirmer' }]} />
          </div>
          <Field label="Notes / À préparer" name="notes" rows={2} />
        </ModalAgenda>
      )}

      {modal === 'pv' && (
        <ModalAgenda title="📄 Rédiger un PV" onSave={savePV} onClose={closeModal}>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
            <Field label="Réunion source" name="reunion" />
            <Field label="Date de la réunion" name="dateReunion" type="date" />
            <Field label="Rédacteur" name="redacteur" />
            <Field label="Prochaine réunion" name="nextDate" type="date" />
          </div>
          <Field label="Participants présents (séparés par virgule)" name="presents" />
          <Field label="Excusés" name="excuses" />
          <Field label="Ordre du jour traité" name="odj" rows={2} />
          <Field label="Points abordés *" name="points" rows={4} />
          <Field label="Décisions prises (une par ligne)" name="decisions" rows={3} />
        </ModalAgenda>
      )}

      {modal === 'decision' && (
        <ModalAgenda title="✅ Nouvelle décision" onSave={saveDecision} onClose={closeModal}>
          <Field label="Décision *" name="texte" rows={2} />
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
            <Field label="Responsable" name="resp" />
            <Field label="Échéance" name="echeance" type="date" />
            <Field label="Priorité" name="prio" opts={[{ v: 'haute', l: '🔴 Haute' }, { v: 'normale', l: '🟡 Normale' }, { v: 'basse', l: '🟢 Basse' }]} />
            <Field label="Réunion source" name="source" />
          </div>
        </ModalAgenda>
      )}

      {/* Panels de détail */}
      {detailReunion && <DetailPanel title={detailReunion.titre} onClose={() => setDetailReunion(null)} color={(TYPE_CFG[detailReunion.type] || TYPE_CFG.autre).color}>
        {[['📅 Date', fmtDate(detailReunion.date) + ' · ' + detailReunion.hstart + ' → ' + detailReunion.hend], ['📍 Lieu', detailReunion.lieu], ['🖥️ Format', detailReunion.format], ['👤 Organisateur', detailReunion.org]].map(([l, v]) => (
          <div key={l} style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 0', borderBottom: '1px solid rgba(255,255,255,.04)' }}>
            <span style={{ fontSize: 11, color: '#667' }}>{l}</span><span style={{ fontSize: 11, color: '#fff' }}>{v}</span>
          </div>
        ))}
        <div style={{ marginTop: 12, marginBottom: 6, fontSize: 10, color: (TYPE_CFG[detailReunion.type] || TYPE_CFG.autre).color, fontWeight: 600, textTransform: 'uppercase' }}>👥 Participants</div>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 5, marginBottom: 12 }}>
          {(detailReunion.participants || []).map((p, i) => <span key={i} style={{ fontSize: 9, padding: '2px 7px', background: 'rgba(255,255,255,.06)', borderRadius: 99, color: '#aaa' }}>{p}</span>)}
        </div>
        <div style={{ fontSize: 10, color: (TYPE_CFG[detailReunion.type] || TYPE_CFG.autre).color, fontWeight: 600, textTransform: 'uppercase', marginBottom: 6 }}>📋 Ordre du jour</div>
        <div style={{ fontSize: 11, color: '#aaa', padding: 10, background: 'rgba(255,255,255,.02)', borderRadius: 8, whiteSpace: 'pre-line', lineHeight: 1.7 }}>{detailReunion.odj}</div>
        {detailReunion.statut !== 'tenue' && (
          <button className="btn-gold" style={{ width: '100%', marginTop: 14, fontSize: 11 }} onClick={() => { setReunions(prev => prev.map(r => r.id === detailReunion.id ? { ...r, statut: 'tenue' } : r)); setDetailReunion(null); }}>✅ Marquer comme tenue</button>
        )}
      </DetailPanel>}

      {detailRdv && <DetailPanel title={detailRdv.objet} onClose={() => setDetailRdv(null)} color={(TYPE_CFG[detailRdv.type] || TYPE_CFG.commercial).color}>
        {[['📅 Date', fmtDate(detailRdv.date) + ' à ' + detailRdv.heure], ['⏱️ Durée', detailRdv.duree], ['🏢 Contact', detailRdv.contact], ['📍 Lieu', detailRdv.lieu], ['👤 Responsable', detailRdv.resp]].map(([l, v]) => (
          <div key={l} style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 0', borderBottom: '1px solid rgba(255,255,255,.04)' }}>
            <span style={{ fontSize: 11, color: '#667' }}>{l}</span><span style={{ fontSize: 11, color: '#fff' }}>{v}</span>
          </div>
        ))}
        {detailRdv.notes && <div style={{ marginTop: 12, fontSize: 11, color: '#aaa', padding: 10, background: 'rgba(255,255,255,.02)', borderRadius: 8 }}>📎 {detailRdv.notes}</div>}
        {detailRdv.statut === 'a_confirmer' && (
          <button className="btn-gold" style={{ width: '100%', marginTop: 14, fontSize: 11 }} onClick={() => { setRdvList(prev => prev.map(r => r.id === detailRdv.id ? { ...r, statut: 'confirme' } : r)); setDetailRdv(null); }}>✅ Confirmer le RDV</button>
        )}
      </DetailPanel>}
    </div>
  );
}

// ── Modal Agenda ──────────────────────────────────────────────────────────────
function ModalAgenda({ title, onSave, onClose, children }) {
  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,.8)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center' }} onClick={onClose}>
      <div style={{ background: '#0d1b2a', border: '1px solid rgba(255,255,255,.12)', borderRadius: 14, padding: 24, width: 580, maxWidth: '95%', maxHeight: '90vh', overflowY: 'auto' }} onClick={e => e.stopPropagation()}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 18 }}>
          <span style={{ fontSize: 15, fontWeight: 600, color: '#fff' }}>{title}</span>
          <button onClick={onClose} style={{ background: 'none', border: 'none', color: '#889', fontSize: 22, cursor: 'pointer' }}>×</button>
        </div>
        {children}
        <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end', marginTop: 18 }}>
          <button className="btn-outline" onClick={onClose}>Annuler</button>
          <button className="btn-gold" onClick={onSave}>Enregistrer</button>
        </div>
      </div>
    </div>
  );
}

// ── Panel latéral de détail ───────────────────────────────────────────────────
function DetailPanel({ title, onClose, color, children }) {
  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,.6)', zIndex: 900, display: 'flex', justifyContent: 'flex-end' }} onClick={onClose}>
      <div style={{ width: 420, maxWidth: '95vw', height: '100vh', background: '#0d1b2a', borderLeft: '1px solid rgba(255,255,255,.1)', overflowY: 'auto', transform: 'none' }} onClick={e => e.stopPropagation()}>
        <div style={{ position: 'sticky', top: 0, background: '#0d1b2a', borderBottom: '1px solid rgba(255,255,255,.07)', padding: '14px 18px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', zIndex: 1 }}>
          <span style={{ fontSize: 13, fontWeight: 600, color, flex: 1, paddingRight: 10 }}>{title}</span>
          <button onClick={onClose} style={{ background: 'none', border: 'none', color: '#667', fontSize: 18, cursor: 'pointer', flexShrink: 0 }}>✕</button>
        </div>
        <div style={{ padding: '18px 18px 40px' }}>{children}</div>
      </div>
    </div>
  );
}

// ── Prévisualisation PV ───────────────────────────────────────────────────────
function PVDoc({ pv }) {
  return (
    <div style={{ background: '#fff', color: '#1a1a1a', borderRadius: 8, padding: '24px 28px', fontSize: 11 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', paddingBottom: 14, borderBottom: '3px solid #C9A84C', marginBottom: 16 }}>
        <div><div style={{ fontFamily: 'Cormorant Garamond, serif', fontSize: 18, fontWeight: 700, color: '#0d1b2a' }}>⚡ FHC GROUPE SARL</div><div style={{ fontSize: 9, color: '#888', marginTop: 2 }}>Financial Hosanna Consulting · Abomey-Calavi, Bénin</div></div>
        <div style={{ textAlign: 'right' }}><div style={{ fontSize: 16, fontWeight: 700, color: '#0d1b2a' }}>PROCÈS-VERBAL</div><div style={{ fontSize: 9, color: '#888', marginTop: 3 }}>Réunion du {pv.dateReunion}</div></div>
      </div>
      {[['Réunion', pv.reunion], ['Date réunion', pv.dateReunion], ['Rédacteur', pv.redacteur], ['Présents', Array.isArray(pv.presents) ? pv.presents.join(', ') : pv.presents]].map(([l, v]) => (
        <div key={l} style={{ display: 'flex', gap: 10, padding: '5px 0', borderBottom: '1px solid #f5f5f5' }}>
          <div style={{ color: '#888', width: 100, flexShrink: 0 }}>{l}</div>
          <div style={{ fontWeight: 500 }}>{v}</div>
        </div>
      ))}
      <div style={{ fontSize: 10, fontWeight: 700, color: '#C9A84C', textTransform: 'uppercase', letterSpacing: .5, margin: '12px 0 6px' }}>Points abordés</div>
      <div style={{ color: '#333', lineHeight: 1.7, whiteSpace: 'pre-line' }}>{pv.points}</div>
      <div style={{ fontSize: 10, fontWeight: 700, color: '#C9A84C', textTransform: 'uppercase', letterSpacing: .5, margin: '12px 0 6px' }}>Décisions prises</div>
      {pv.decisions.map((d, i) => (
        <div key={i} style={{ display: 'flex', gap: 8, padding: '5px 0', borderBottom: '1px solid #f5f5f5' }}>
          <div style={{ width: 18, height: 18, borderRadius: 3, border: '1.5px solid #C9A84C', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 9, flexShrink: 0 }}>{i + 1}</div>
          <div>{d}</div>
        </div>
      ))}
      <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 20, paddingTop: 10, borderTop: '1px solid #eee' }}>
        <div style={{ textAlign: 'center', width: '44%' }}><div style={{ borderBottom: '1px solid #ccc', height: 32, marginBottom: 4 }} /><div style={{ fontSize: 9, color: '#aaa' }}>Le Rédacteur — {pv.redacteur}</div></div>
        <div style={{ textAlign: 'center', width: '44%' }}><div style={{ borderBottom: '1px solid #ccc', height: 32, marginBottom: 4 }} /><div style={{ fontSize: 9, color: '#aaa' }}>Le Directeur Général</div></div>
      </div>
    </div>
  );
}
